import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
import { registerUniversalForm } from './sendForm'
import { registerAudioPlayer } from './audioPlayer'
import { registerPageFeedback } from './pageFeedback'
import { registerCookieBanner } from './cookieBanner'
import './phoneMask'
import './post'

registerUniversalForm(Alpine);
registerAudioPlayer(Alpine);
registerPageFeedback(Alpine);
registerCookieBanner(Alpine);

window.Alpine = Alpine
Alpine.plugin(focus)
Alpine.start()
